import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { Link, useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalBody, UncontrolledDropdown } from "reactstrap";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Button, Col, Icon, Row, RSelect } from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { INVENTORY_TYPE } from "../../utils/Utils";


const INVENTORY_TYPE_OPTIONS = Object.keys(INVENTORY_TYPE).map((c) => ({
  label: INVENTORY_TYPE[c],
  value: c,
}));

const DEFAULT_INVENTORY = {
  id: "",
  productId: "",
  quantity: 1,
  type: "IN",
  description: null,
  truckId: "",
  userId: ""
};

const InventoryPack = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const [view, setView] = useState({
    edit: false,
    add: false,
    details: false,
    isDelete: false,
  });
  const { errors, register, handleSubmit, reset, getValues, control, watch } = useForm({
    defaultValues: {
      ...DEFAULT_INVENTORY,
    },
  });
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [editId, setEditedId] = useState();
  const [productOptions, setProductOptions] = useState([]);
  const [deleteId, setDeleteId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [summary, setSummary] = useState({});
  const [rangeDate, setRangeDate] = useState({
    start: searchParams.get("start") ? moment(searchParams.get("start")).startOf("days").toDate() : moment().startOf("months").toDate(),
    end: searchParams.get("end") ? moment(searchParams.get("end")).endOf("days").toDate() : moment().endOf("months").toDate(),
  });
  const [filter, setFilter] = useState({
    type: searchParams.get("type") || 'OUT',
  });

  const colTable = [
    {
      Header: "Tên sản phẩm",
      accessor: (item) => item.productPack?.name,
    },
    {
      Header: "Số lượng",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        value={item.quantity}
        displayType={"text"}
        decimalScale={2}
        thousandSeparator={","}
        thousandsGroupStyle="thousand" />
      ,
    },
    {
      Header: "Loại",
      accessor: (item) => INVENTORY_TYPE[item.type],
    },
    {
      Header: "Mã đơn",
      accessor: (item) => (item.billId ? <Link to={`/bill/${item.billId}`}>{item.billId}</Link> : ""),
    },

    {
      Header: "Ghi chú",
      accessor: (item) => item.description,
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle tag="a" className="btn btn-icon dropdown-toggle btn-trigger">
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onEditClick(item.id);
                        toggle("edit");
                      }}
                    >
                      <Icon name="edit" className="text-danger"></Icon>
                      <span>Sửa</span>
                    </DropdownItem>
                  </li>
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  useEffect(() => {
    GET(`/inventory-pack/list-product-pack`, {}, true).then(({ data }) => {
      setProductOptions(
        data.map((e) => ({
          value: e.id,
          label: e.name,
          data: e,
        }))
      );
    });
  }, []);
  // Changing state value when searching name
  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
      ...(filter.type ? { type: filter.type } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });

    setLoading(true);
    setData([]);
    let params = {
      startDate: moment(rangeDate.start).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.end).format("YYYY-MM-DD"),
      ...(filter.type ? { type: filter.type } : {}),
    };

    GET(`/inventory-pack/list-inventories`, params, true)
      .then(({ data }) => {
        setData(data.rows);
        setSummary(data.summary)
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow, filter]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const onEditClick = (id, type = "") => {
    setLoading(true);
    setEditedId(id);

    GET(`inventory-pack/${id}`, {}, true)
      .then(({ data }) => {
        reset({
          ...data,
        });
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại.");
        onFormCancel();

      })
      .finally(() => {
        setLoading(false);
      });
  };

  const resetData = () => {
    setEditedId("");
    onFormCancel();
    setTimeNow(moment().valueOf());
  };

  // Submits form data
  const onHandleSubmit = () => {
    setLoading(true);
    const { productId, quantity, type, description } = getValues();

    const formData = {
      productId,
      quantity,
      type,
      description,
    };

    const request = editId ? PUT(`/inventory-pack/${editId}`, formData, {}, true) : POST("/inventory-pack", formData, {}, true);

    request
      .then((res) => {
        if (editId) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        resetData();
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false });
    reset(DEFAULT_INVENTORY);
    setEditedId();
    setDeleteId();
  };

  const deleteOrder = (id) => {
    if (!id) {
      return;
    }
    DELETE(`/inventory-pack/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa nhập xuất kho tải thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại.");
      });
  };

  const onRangeChange = (dates) => {
    const [start, end] = dates;
    setRangeDate({
      start: start ? moment(start)?.startOf("days").toDate() : start,
      end: end ? moment(end)?.endOf("days").toDate() : end,
    });
    if (start && end) {
      setTimeNow(moment().valueOf());
    }
  };

  return (
    <React.Fragment>
      <Head title="Quản lý nhập xuất túi"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Quản lý nhập xuất túi</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div className="toggle-expand-content" style={{ display: smOption ? "block" : "none" }}>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap" style={{ width: "200px" }}>
                        <DatePicker
                          onKeyDown={(e) => {
                            e.preventDefault();
                          }}
                          placeholderText="Lọc theo ngày"
                          selected={rangeDate.start}
                          startDate={rangeDate.start}
                          endDate={rangeDate.end}
                          onChange={onRangeChange}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>

                    <li>
                      <div className="form-control-wrap" style={{ width: 150 }}>
                        <RSelect
                          isClearable
                          placeholder="Loại"
                          options={INVENTORY_TYPE_OPTIONS}
                          value={INVENTORY_TYPE_OPTIONS.find((c) => c.value === filter.type)}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              type: val?.value || undefined,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          onClick={() => {
                            resetData();
                            toggle("add");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm nhập xuất kho</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div id="DataTables_Table_1_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div className="dataTables_length" id="DataTables_Table_1_length"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                    headerRow={<tr>
                      <td>Tổng túi:</td>
                      <td className="text-right">
                        <NumericFormat
                          value={summary?.count}
                          displayType={"text"}
                          decimalScale={2}
                          thousandSeparator={","}
                          thousandsGroupStyle="thousand" />
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal isOpen={view.add || view.edit} toggle={() => onFormCancel()} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">{editId ? "Sửa" : "Thêm"} nhập xuất kho</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onHandleSubmit)}>
                  <Row className="g-3">
                    <Col size="12">
                      <div className="form-group">
                        <label className="form-label" >
                          Sản phẩm<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="productId"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <RSelect inputRef={ref} name={name} options={productOptions} value={productOptions.find((c) => c.value === value)} onChange={(val) => onChange(val.value)} />
                            )}
                          />
                          <ErrorMessage errors={errors} name="productId" render={({ message }) => <span className="invalid">{message}</span>} />
                        </div>
                      </div>
                    </Col>

                    <Col size="12">
                      <div className="form-group">
                        <label className="form-label" >
                          Số lượng
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="quantity"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) => onChange(val.floatValue)}
                              />
                            )}
                          />
                          <ErrorMessage errors={errors} name="quantity" render={({ message }) => <span className="invalid">{message}</span>} />
                        </div>
                      </div>
                    </Col>
                    <Col size="12">
                      <div className="form-group">
                        <label className="form-label" >
                          Xuất/Nhập<span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="type"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                ref={ref}
                                name={name}
                                options={INVENTORY_TYPE_OPTIONS.filter(e => e.value === 'IN')}
                                value={INVENTORY_TYPE_OPTIONS.find((c) => c.value === value) || null}
                                onChange={(val) => {
                                  onChange(val.value);
                                }}
                              />
                            )}
                          />
                          <ErrorMessage errors={errors} name="type" render={({ message }) => <span className="invalid">{message}</span>} />
                        </div>
                      </div>
                    </Col>

                    <Col size="12">
                      <div className="form-group">
                        <label className="form-label" >
                          Ghi chú
                        </label>
                        <div className="form-control-wrap">
                          <input type="text" className="form-control" name="description" ref={register()} />
                        </div>
                      </div>
                    </Col>

                    <Col size="12">
                      <Button color="primary" type="submit">
                        <Icon className="plus"></Icon>
                        <span>{editId ? "Sửa" : "Thêm"} nhập xuât kho</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">Bạn có chắc muốn xoá nhập xuất kho này không ? </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button color="light" size="lg" className="btn-mw mr-5" onClick={() => onFormCancel()}>
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteOrder(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default InventoryPack;
